import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight, AlertTriangle } from "lucide-react";
import { problems } from "@/data/problems";
import { useLang } from "@/i18n/LanguageContext";

export const ProblemsGrid = () => {
  const { lang } = useLang();
  return (
    <section className="py-20 md:py-24 bg-secondary/40">
      <div className="container">
        <div className="max-w-2xl mb-12">
          <span className="inline-flex items-center gap-2 text-accent font-semibold uppercase tracking-widest text-sm">
            <AlertTriangle className="w-4 h-4" /> {lang === "de" ? "Notfälle" : "Emergencies"}
          </span>
          <h2 className="font-display text-4xl md:text-5xl text-primary mt-3 mb-4">
            {lang === "de" ? "Ihr Problem – unsere Lösung" : "Your problem – our solution"}
          </h2>
          <p className="text-muted-foreground text-lg">
            {lang === "de"
              ? "Wählen Sie Ihre Situation und erhalten Sie sofort die richtige Hilfe."
              : "Pick your situation and get the right help instantly."}
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {problems.slice(0, 9).map((p) => {
            const Icon = (Icons as any)[p.icon] ?? Icons.AlertCircle;
            return (
              <Link
                key={p.slug}
                to={`/probleme/${p.slug}`}
                className="group bg-card border border-border rounded-xl p-5 hover:border-accent hover:shadow-elegant transition-all flex items-start gap-4"
              >
                <div className="w-11 h-11 rounded-lg bg-accent/15 grid place-items-center text-accent shrink-0 group-hover:bg-accent group-hover:text-accent-foreground transition-colors">
                  <Icon className="w-5 h-5" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-display text-base text-primary leading-tight mb-1">
                    {lang === "de" ? p.titleDe : p.titleEn}
                  </h3>
                  <p className="text-xs text-muted-foreground line-clamp-2">
                    {lang === "de" ? p.shortDe : p.shortEn}
                  </p>
                </div>
                <ArrowRight className="w-4 h-4 text-accent opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all shrink-0 mt-1" />
              </Link>
            );
          })}
        </div>
        <div className="mt-10 text-center">
          <Link to="/probleme" className="inline-flex items-center gap-2 text-accent font-semibold hover:gap-3 transition-all">
            {lang === "de" ? "Alle Notfälle ansehen" : "See all emergencies"} <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};